import ActionTypes from 'app/redux-boneyard/auth/ActionTypes';
import reducer from 'app/redux-boneyard/auth/reducer';
import routes from 'app/auth/routes';

export default {
  reducers: {
    auth: reducer,
  },
  actionTypes: ActionTypes,
  routes,
};
